import { FaGithub, FaInstagram, FaTwitter } from 'react-icons/fa';

export const footerData = [
  {
    id: 1,
    icon: <FaTwitter/>,
    link: "https://twitter.com/onu_princeley"
  },
  {
    id: 2,
    icon: <FaGithub/>,
    link: "https://github.com/steno1" 
  },
  {
    id: 3,
    icon: <FaInstagram/>,
    link: "https://www.instagram.com/onuprinceley/" 
  }
];

export const links=[
    {id:4, link:"#", title:"Home"},
    {id:5, link:"#about", title:"About"},
    {id:6, link:"#services", title:"Service"},
    {id:7, link:"#portfolio", title:"Portfolio"},
    {id:8, link:"#contact", title:"Contact"},
]
